import { render, staticRenderFns } from "./EmulateCustomerButton.vue?vue&type=template&id=87257264&"
import script from "./EmulateCustomerButton.vue?vue&type=script&lang=js&"
export * from "./EmulateCustomerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports